import { borderWidthVars, spacingVars } from '@tundr/ds-foundations';
import { semanticTokenVars } from '@tundr/ds-tokens';
import { style } from '@vanilla-extract/css';

export const modalActionsContainerClass = style({
  display: 'flex',
  width: '100%',
  marginTop: spacingVars.lg,
  padding: `${spacingVars.xl} ${spacingVars.none} ${spacingVars.none}`,
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: spacingVars.lg,
});

export const modalActionsContainerWithBorderClass = style({
  paddingTop: `calc(${spacingVars.xl} - ${borderWidthVars.xs})`,
  borderTop: `${borderWidthVars.xs} solid ${semanticTokenVars.border.neutral.default.subtle}`,
});
